var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght300_GRAD-25_opsz20",
    d: "M274.438-685.805l-4.8,4.79a.62.62,0,0,1-.475.219.767.767,0,0,1-.48-.256.685.685,0,0,1-.228-.483.694.694,0,0,1,.236-.475l4.764-4.776-4.792-4.8a.625.625,0,0,1-.212-.469.748.748,0,0,1,.241-.489.7.7,0,0,1,.48-.247.688.688,0,0,1,.494.233l4.773,4.8,4.807-4.8a.676.676,0,0,1,.483-.228.729.729,0,0,1,.5.242.692.692,0,0,1,.222.483.694.694,0,0,1-.236.475l-4.792,4.8,4.792,4.8a.669.669,0,0,1,.226.455.673.673,0,0,1-.226.475.7.7,0,0,1-.48.247.666.666,0,0,1-.489-.238Z",
    transform: "translate(-268.45 692.795)",
    fill: "#f59064"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.44deb2b9.svg";
export { ForwardRef as ReactComponent };